var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NsRadioGroup',{attrs:{"label":_vm.schema.label,"name":_vm.schema.key,"items":_vm.schema.items},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }